import { render, staticRenderFns } from "./inbound.vue?vue&type=template&id=46c3cb87&scoped=true&"
import script from "./inbound.vue?vue&type=script&lang=js&"
export * from "./inbound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46c3cb87",
  null
  
)

export default component.exports